import { useParams } from 'react-router-dom';
import React, { useState } from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const Remedy2Detail = () => {
  const { id } = useParams();
  const [voucher, setVoucher] = useState('');
  const [verified, setVerified] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [paymentOption, setPaymentOption] = useState('');

  const deal = {
    id,
    title: "Maldives Romantic Retreat",
    location: "Maldives",
    description: "Luxury stay with sunset views and private pool.",
    dealPrice: 1000,
    offerPrice: 800,
    business: {
      name: "Oceanic Hotels",
      type: "Hotel",
      contact: "contact@oceanichotels.com",
      location: "Malé, Maldives"
    },
    userReviews: 120,
    image: `/api/downloads/thinktravel/deals/${id}.png`,
  };

  const handleVerify = () => {
    if (voucher === 'LOVE50') {
      setVerified(true);
      setDiscount(50); // 50% off example
    } else {
      setVerified(false);
      setDiscount(0);
    }
  };

  const finalPrice = discount > 0 ? deal.offerPrice * (1 - discount / 100) : deal.offerPrice;

  const [voucherVisible, setVoucherVisible] = useState(false);

  const handleBookNow = () => {
    if (paymentOption) {
      setVoucherVisible(true);
    } else {
      alert('Please select a payment option before booking.');
    }
  };

  const handleDownloadPDF = async () => {
    const input = document.getElementById('voucherSection');
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${deal?.dealTitle || "voucher"}.pdf`);
  };


  return (
    <div className="text-white p-6 max-w-4xl mx-auto bg-pink-400">
      <img src={deal.image} alt={deal.title} className="w-full h-64 object-cover rounded mb-4" />

      <h2 className="text-3xl font-bold text-yellow-200">{deal.title}</h2>
      <p className="text-white">{deal.location}</p>

      <div className="mt-4 text-m">
        <p>{deal.description}</p>
        <p className="mt-2">Original Price: ₹{deal.dealPrice}</p>
        <p>Offer Price: ₹{deal.offerPrice}</p>
        {discount > 0 && (
          <p className="text-green-600 font-bold">Discount Applied: ₹{deal.offerPrice - finalPrice}</p>
        )}
        <p className="text-xl mt-2 font-semibold">Final Price: ₹{finalPrice}</p>
      </div>

      <div className="mt-4">
        <h3 className="font-semibold">Business Details</h3>
        <p>{deal.business.name} ({deal.business.type})</p>
        <p>{deal.business.location}</p>
        <p>{deal.business.contact}</p>
      </div>

      <div className="mt-6 flex flex-row">
        <input 
          type="text"
          value={voucher}
          onChange={(e) => setVoucher(e.target.value)}
          placeholder="Enter Discount Voucher"
          className="border p-2 rounded w-64 mr-2 h-10"
        />
        <button 
          onClick={handleVerify}
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 h-10 w-40"
        >
          Verify Voucher
        </button>
        {voucher && !verified && <p className="text-red-500 mt-2">Invalid voucher code.</p>}
      </div>

      {verified && (
        <button 
          onClick={() => alert("Discount Applied")}
          className="mt-2 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Apply Voucher
        </button>
      )}

      <div className="mt-6">
        <h4 className="font-semibold mb-2 text-white">Select Payment Option:</h4>
        <div className="space-y-2">
          {["Pay Online", "I have Paid", "Will Pay At Destination"].map(opt => (
            <label key={opt} className="block">
              <input 
                type="radio" 
                name="payment" 
                value={opt}
                onChange={(e) => setPaymentOption(e.target.value)}
              />
              <span className="ml-2">{opt}</span>
            </label>
          ))}
        </div>
        {paymentOption && (
          <p className="mt-2 text-yellow-200">You selected: {paymentOption}</p>
        )}
        {/* Book Now Button */}
        <button
            className="mt-4 px-6 py-2 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-full"
            onClick={handleBookNow}
            disabled={!paymentOption}
        >
            Book Now
        </button>
        {/* Confirmation Voucher */}
        {voucherVisible && (
            <>
            <div className="mt-8 bg-white shadow-lg rounded-lg p-4 text-black" id="voucherSection">
                <img
                src={deal?.image || "/default-deal.jpg"}
                alt="Deal"
                className="w-full h-64 object-cover rounded-lg mb-4"
                />

                <h2 className="text-2xl font-bold text-black">{deal?.dealTitle}</h2>
                <h3 className="text-lg text-gray-800 mb-2">{deal?.location}</h3>
                <p className="text-gray-900 mb-4">{deal?.description}</p>

                <div className="text-base text-gray-800 space-y-1 mb-4">
                <p className='text-black'><strong>Original Price:</strong> ₹{deal?.originalPrice}</p>
                <p className='text-black'><strong>Offer Price:</strong> ₹{deal?.offerPrice}</p>
                <p className='text-black'><strong>Final Price:</strong> ₹{deal?.finalPrice}</p>
                </div>

                <h4 className="text-lg font-semibold mt-4 mb-2">Business Details</h4>
                <div className="text-sm text-gray-800 space-y-1">
                <p className='text-black'><strong>{deal?.business.name}</strong> ({deal?.business.type})</p>
                <p className='text-black'>{deal?.business.location}</p>
                <p className='text-black'>{deal?.contact}</p>
                </div>
            </div>

            {/* This button stays outside the voucher for screen use only */}
            <button
                onClick={handleDownloadPDF}
                className="mt-6 px-6 py-2 bg-green-600 text-white rounded-full hover:bg-green-700"
            >
                Download PDF Voucher
            </button>
            </>
        )}
      </div>
    </div>
  );
};

export default Remedy2Detail;
